// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-peduli-asst{
  .logo-pi{
      width: 260px;
      margin-top: 5%;
      display: flex center;
  }
}
  
.card-peduli-insani{
  display: flex center !important;
  flex-direction: column;
  margin: 10% auto;
  width: 480px;
  margin-left: 340px;
  margin-top: 28px;
  background-color: #5598AE;
  opacity: 0.85;
  border-radius: 10px;
  height: 345px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

.card-assessment {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  margin-top: 60px;
  background-color: #0592cf;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 15px;
  height: auto;
  width: 420px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.card-assessment .txt-values {
  font-size: 16px;
  font-weight: bold;
}

.card-assessment .txt-definisi {
  font-size: 14px;
  margin-top: 10px;
  text-align: left;
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
  .card-assessment {
    width: 92%; /* Lebar penuh pada perangkat mobile */
    max-width: none; /* Menghapus batasan lebar maksimum */
    margin-top: 30px; /* Penyesuaian margin-top untuk tampilan mobile */
    box-shadow: none; /* Menghapus shadow pada perangkat mobile */
  }
}


.card-quest {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #176b87;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 15px;
  height: auto;
  width: 420px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
  .card-quest {
      width: 92%; /* Lebar penuh pada perangkat mobile */
      margin-top: 15px; /* Penyesuaian margin-top untuk tampilan mobile */
  }
}
  
.card-quest:hover {
  transform: scale(1.05); /* Enlarge the card on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a shadow on hover */
}
.col-75 {
  float: left;
  width: 200% !important;
  margin-top: 6px;
  height: 20px;
}

.feedback {
  margin-left: 5%;
  border-radius: 20px !important;
  margin-top: 5% !important;
  width: 90%;
  height: auto;
  text-align: center !important;
  justify-content: center;
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
  .feedback {
      margin-top: 10%; /* Penyesuaian margin-top untuk tampilan mobile */
  }
}

.header-feedback {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #0592cf;
  margin-bottom: 2%;
  padding-left: 2%;
  margin-top: 3%;
  margin-left: -50% !important;
}

/* Media query untuk iPad dengan lebar layar kurang dari 768px */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .header-feedback {
    margin-left: -30% !important; /* Set ulang margin-left untuk tampilan iPad */
    /* text-align: center; Center text pada tampilan iPad */
  }
}

/* Tambahan untuk tampilan desktop */
@media screen and (min-width: 1025px) {
  .header-feedback {
    margin-left: -20% !important; /* Set ulang margin-left untuk tampilan iPad */
    /* text-align: center; Center text pada tampilan iPad */
  }
}

.komentar {
  text-align: left;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  height: 130px;
  margin-top: 20px;
  border: 1px solid;
  border-radius: 10px;
  padding-left: 2%;
  padding-top: 1%;
}

/* Media query untuk iPad dengan lebar layar kurang dari 768px */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .feedback {
      margin-top: 10%; /* Penyesuaian margin-top untuk tampilan iPad */
  }
}

.font-option{
  font-size: 15px;
  text-align: right !important;
}

.back-icon-page{
  margin-top: -12%;
  margin-left: 6%;
  display:inline-block;
  color: black;
  font-size: 1900;
  position: absolute;
  margin-bottom: 4%;
}

.input {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px; /* Size of the indicator */
  height: 20px; /* Size of the indicator */
  background-color: #2196F3; /* Color of the indicator when checked */
  border-radius: 50%; /* Make it circular */
}

.btn-page1{
  width: 100%;
  text-align:center;
  
}

.btn-feedback-form{
  display: inline-block;
  background-color: #3B6AC0;
  color: #fff;
  border: 2px solid rgb(8, 96, 128);
  border-radius: 10px;
  border: 4px;
  padding: 10px;
  margin: 5px;
  font-family: 'Poppins';
  font-weight: bold;
  cursor: pointer;
  width: 120px;
  margin-top: 4%;
  margin-bottom: 5%;
}

.emoji-options i {
  font-size: 2em;
  cursor: pointer;
}

.emoji-option[data-emoji="1"]:hover {
  color: #59c1bd;
}

.emoji-option[data-emoji="2"]:hover {
  color: #ffff00;
}

.emoji-option[data-emoji="3"]:hover {
  color: #ff0000;
}

.emoji-options button.active {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/AssessmentPage/AssessmentPage.css"],"names":[],"mappings":"AAAA;EACE;MACI,YAAY;MACZ,cAAc;MACd,oBAAoB;EACxB;AACF;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE;IACE,UAAU,EAAE,sCAAsC;IAClD,eAAe,EAAE,qCAAqC;IACtD,gBAAgB,EAAE,iDAAiD;IACnE,gBAAgB,EAAE,2CAA2C;EAC/D;AACF;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE;MACI,UAAU,EAAE,sCAAsC;MAClD,gBAAgB,EAAE,iDAAiD;EACvE;AACF;;AAEA;EACE,sBAAsB,EAAE,8BAA8B;EACtD,wCAAwC,EAAE,0BAA0B;AACtE;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE;MACI,eAAe,EAAE,iDAAiD;EACtE;AACF;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,gEAAgE;AAChE;EACE;IACE,4BAA4B,EAAE,8CAA8C;IAC5E,uDAAuD;EACzD;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,4BAA4B,EAAE,8CAA8C;IAC5E,uDAAuD;EACzD;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE;MACI,eAAe,EAAE,+CAA+C;EACpE;AACF;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,0BAA0B;EACxC,yBAAyB,EAAE,wCAAwC;EACnE,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".logo-peduli-asst{\n  .logo-pi{\n      width: 260px;\n      margin-top: 5%;\n      display: flex center;\n  }\n}\n  \n.card-peduli-insani{\n  display: flex center !important;\n  flex-direction: column;\n  margin: 10% auto;\n  width: 480px;\n  margin-left: 340px;\n  margin-top: 28px;\n  background-color: #5598AE;\n  opacity: 0.85;\n  border-radius: 10px;\n  height: 345px;\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n}\n\n.card-assessment {\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n  margin-top: 60px;\n  background-color: #0592cf;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 15px;\n  height: auto;\n  width: 420px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n.card-assessment .txt-values {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.card-assessment .txt-definisi {\n  font-size: 14px;\n  margin-top: 10px;\n  text-align: left;\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n  .card-assessment {\n    width: 92%; /* Lebar penuh pada perangkat mobile */\n    max-width: none; /* Menghapus batasan lebar maksimum */\n    margin-top: 30px; /* Penyesuaian margin-top untuk tampilan mobile */\n    box-shadow: none; /* Menghapus shadow pada perangkat mobile */\n  }\n}\n\n\n.card-quest {\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n  margin-top: 20px;\n  background-color: #176b87;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 15px;\n  height: auto;\n  width: 420px;\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n  .card-quest {\n      width: 92%; /* Lebar penuh pada perangkat mobile */\n      margin-top: 15px; /* Penyesuaian margin-top untuk tampilan mobile */\n  }\n}\n  \n.card-quest:hover {\n  transform: scale(1.05); /* Enlarge the card on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a shadow on hover */\n}\n.col-75 {\n  float: left;\n  width: 200% !important;\n  margin-top: 6px;\n  height: 20px;\n}\n\n.feedback {\n  margin-left: 5%;\n  border-radius: 20px !important;\n  margin-top: 5% !important;\n  width: 90%;\n  height: auto;\n  text-align: center !important;\n  justify-content: center;\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n  .feedback {\n      margin-top: 10%; /* Penyesuaian margin-top untuk tampilan mobile */\n  }\n}\n\n.header-feedback {\n  font-size: 18px !important;\n  font-weight: bold !important;\n  color: #0592cf;\n  margin-bottom: 2%;\n  padding-left: 2%;\n  margin-top: 3%;\n  margin-left: -50% !important;\n}\n\n/* Media query untuk iPad dengan lebar layar kurang dari 768px */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .header-feedback {\n    margin-left: -30% !important; /* Set ulang margin-left untuk tampilan iPad */\n    /* text-align: center; Center text pada tampilan iPad */\n  }\n}\n\n/* Tambahan untuk tampilan desktop */\n@media screen and (min-width: 1025px) {\n  .header-feedback {\n    margin-left: -20% !important; /* Set ulang margin-left untuk tampilan iPad */\n    /* text-align: center; Center text pada tampilan iPad */\n  }\n}\n\n.komentar {\n  text-align: left;\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n  height: 130px;\n  margin-top: 20px;\n  border: 1px solid;\n  border-radius: 10px;\n  padding-left: 2%;\n  padding-top: 1%;\n}\n\n/* Media query untuk iPad dengan lebar layar kurang dari 768px */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .feedback {\n      margin-top: 10%; /* Penyesuaian margin-top untuk tampilan iPad */\n  }\n}\n\n.font-option{\n  font-size: 15px;\n  text-align: right !important;\n}\n\n.back-icon-page{\n  margin-top: -12%;\n  margin-left: 6%;\n  display:inline-block;\n  color: black;\n  font-size: 1900;\n  position: absolute;\n  margin-bottom: 4%;\n}\n\n.input {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px; /* Size of the indicator */\n  height: 20px; /* Size of the indicator */\n  background-color: #2196F3; /* Color of the indicator when checked */\n  border-radius: 50%; /* Make it circular */\n}\n\n.btn-page1{\n  width: 100%;\n  text-align:center;\n  \n}\n\n.btn-feedback-form{\n  display: inline-block;\n  background-color: #3B6AC0;\n  color: #fff;\n  border: 2px solid rgb(8, 96, 128);\n  border-radius: 10px;\n  border: 4px;\n  padding: 10px;\n  margin: 5px;\n  font-family: 'Poppins';\n  font-weight: bold;\n  cursor: pointer;\n  width: 120px;\n  margin-top: 4%;\n  margin-bottom: 5%;\n}\n\n.emoji-options i {\n  font-size: 2em;\n  cursor: pointer;\n}\n\n.emoji-option[data-emoji=\"1\"]:hover {\n  color: #59c1bd;\n}\n\n.emoji-option[data-emoji=\"2\"]:hover {\n  color: #ffff00;\n}\n\n.emoji-option[data-emoji=\"3\"]:hover {\n  color: #ff0000;\n}\n\n.emoji-options button.active {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
